import i18next from "i18next"
import moment from "moment"
import { initReactI18next } from "react-i18next"
import { defaultLanguage } from "utils/api"

// Components re-render on this event, so moment has to switch before they format dates.
i18next.on("languageChanged", (lng) => moment.locale(lng))

i18next.use(initReactI18next).init({
  lng: defaultLanguage(),
  fallbackLng: "de",
  resources: {},
  interpolation: { escapeValue: false, prefix: "%{", suffix: "}" },
  // Disable default missing key handler — shim handles it
  saveMissing: false
})

export default i18next
